import styled from 'styled-components';

export const GalleryStyles = styled.div`
  /* FIXME: костыль, исправляет верстку компонента MultiplePreview */
  && > div {
    width: 100%;
    height: 100%;
    & > span {
      display: block;
      width: 100%;
      height: 100%;
      outline: none;
    }
    /* FIXME: удалить когда починят в KIT, реквест отправлен */
    & > div {
      z-index: 9999999;
    }
  }

  @media (max-width: 512px) {
    display: none;
  }
`;

export const GalleryContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
